import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Radio,
  Space,
  Slider,
  Upload,
  message,
  Input,
} from "antd";
import ImgCrop from "antd-img-crop";
import imageCompression from "browser-image-compression";
import { Domain, request } from "../../../../config/API";
import authHeader from "../../../../redux/services/authHeader";
import shortid from "shortid";
import getBase64 from "../../../../helpers/getBase64";
import { PlusOutlined } from "@ant-design/icons";
import { InputColor } from "./InputColor";
import PreviewImage from "./PreviewImage";

const WaveCodeStyle = ({ form }) => {
  const [pPicker, setPPicker] = useState(false);
  const [sPicker, setSPicker] = useState(false);
  const [qrSetting, setQrSettings] = useState({
    size: undefined,
    quietZone: undefined,
    ecLevel: undefined,
    bgColor: undefined,
    fgColor: undefined,
    logoImage: undefined,
    logoWidth: undefined,
    logoHeight: undefined,
    logoOpacity: undefined,
    qrStyle: undefined,
    eyeRadius: undefined,
  });

  const [logoImageList, setLogoImageList] = useState([]);
  const controller = new AbortController();
  const options = {
    signal: controller.signal,
    maxSizeMB: 1,
  };

  const postLogoImage = ({ file, onSuccess, onError }) => {
    const formData = new FormData();

    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("logoImage", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortid(),
              name: data.logoImage,
              status: "done",
              url: Domain + "/data/" + data.logoImage,
            };

            setLogoImageList([...logoImageList, newData]);
            setQrSettings({ ...qrSetting, logoImage: newData?.name });

            form.setFieldValue(
              ["qrSetting", "logoImage"],
              (newData?.name ? newData?.name : null) ||
                (newData ? newData : null)
            );
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });
        return;
      })
      .catch(function (error) {
        console.error(error.message);
      });
  };
  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const handleImageRemove = (image, key) => {
    form.setFieldValue(["qrSetting", "logoImage"], "");
  };

  useEffect(() => {
    const setLogoValue = (logoWidth, logoHeight, logoOpacity) => {
      setQrSettings((value) => {
        return {
          ...value,
          logoWidth: logoWidth,
          logoHeight: logoHeight,
          logoOpacity: logoOpacity,
        };
      });
      form.setFieldValue(["qrSetting", "logoWidth"], logoWidth);
      form.setFieldValue(["qrSetting", "logoHeight"], logoHeight);
      form.setFieldValue(["qrSetting", "logoOpacity"], logoOpacity);
    };

    if (qrSetting.logoImage) {
      setLogoValue(50, 50, 1);
    } else {
      setLogoValue(undefined, undefined, undefined);
    }
  }, [form, qrSetting.logoImage]);

  return (
    <>
      <span
        onClick={() => {
          setPPicker(false);
          setSPicker(false);
        }}
      >
        <Row gutter={10} style={{ marginTop: 24, justifyContent: "center" }}>
          <Col xs={12} md={4}>
            <h4>Show Qr code in profile</h4>
          </Col>
          <Col xs={12} md={20}>
            <Form.Item name="showQr">
              <Radio.Group>
                <Space
                  wrap={true}
                  style={{
                    display: "flex",
                  }}
                >
                  <Radio.Button style={{ borderRadius: 8 }} value={true}>
                    Show
                  </Radio.Button>
                  <Radio.Button style={{ borderRadius: 8 }} value={false}>
                    Hide
                  </Radio.Button>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {/* color picker */}
        <Row span={24} style={{ marginTop: 24 }}>
          <Col xs={24} md={4}>
            <h4>Select Colors</h4>
          </Col>
          <Col xs={24} md={9} className="ecLevel" style={{ zIndex: 9999 }}>
            <Form.Item name={["qrSetting", "fgColor"]}>
              <InputColor
                placeholder="#000000"
                togglePicker={pPicker}
                onClick={(e) => {
                  e.stopPropagation();
                  setPPicker(!pPicker);
                }}
              ></InputColor>
            </Form.Item>
          </Col>
          <Col xs={24} md={9} className="ecLevel" style={{ zIndex: 9999 }}>
            <Form.Item name={["qrSetting", "bgColor"]}>
              <InputColor
                placeholder="#FFFFFF"
                togglePicker={sPicker}
                onClick={(e) => {
                  e.stopPropagation();
                  setSPicker(!sPicker);
                }}
              ></InputColor>
            </Form.Item>
          </Col>
        </Row>

        <Row span={24} style={{ marginTop: 24 }}>
          <Col xs={12} md={4}>
            <h4>EC Level</h4>
            <p style={{ fontSize: 10, color: "lightgray" }}>
              *Error Correction
            </p>
          </Col>
          <Col xs={12} md={20}>
            <Form.Item name={["qrSetting", "ecLevel"]}>
              <Radio.Group
                value={qrSetting.ecLevel}
                onChange={(e) =>
                  setQrSettings({
                    ...qrSetting,
                    ecLevel: e.target.value,
                  })
                }
              >
                <Space
                  wrap={true}
                  style={{
                    display: "flex",
                  }}
                >
                  <Radio.Button style={{ borderRadius: 8 }} value={"L"}>
                    Low
                  </Radio.Button>
                  <Radio.Button style={{ borderRadius: 8 }} value={"M"}>
                    Medium
                  </Radio.Button>
                  <Radio.Button style={{ borderRadius: 8 }} value={"Q"}>
                    Quartile
                  </Radio.Button>
                  <Radio.Button style={{ borderRadius: 8 }} value={"H"}>
                    High
                  </Radio.Button>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10} style={{ marginTop: 24 }}>
          <Col xs={12} md={4}>
            <h4>Style</h4>
          </Col>
          <Col xs={12} md={20}>
            <Form.Item name={["qrSetting", "qrStyle"]}>
              <Radio.Group
                value={qrSetting.qrStyle}
                onChange={(e) =>
                  setQrSettings({
                    ...qrSetting,
                    qrStyle: e.target.value,
                  })
                }
              >
                <Space
                  style={{
                    display: "flex",
                  }}
                  wrap={true}
                >
                  <Radio.Button style={{ borderRadius: 8 }} value={"squares"}>
                    Squares
                  </Radio.Button>
                  <Radio.Button style={{ borderRadius: 8 }} value={"dots"}>
                    Dots
                  </Radio.Button>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10} style={{ marginTop: 24 }}>
          <Col xs={12} md={4}>
            <h4>Eye Radius</h4>
          </Col>
          <Col xs={12} md={20}>
            <Form.Item name={["qrSetting", "eyeRadius"]}>
              <Slider
                max={50}
                value={qrSetting.eyeRadius}
                onChange={(e) => setQrSettings({ ...qrSetting, eyeRadius: e })}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10} style={{ marginTop: 24 }}>
          <Col xs={12} md={4}>
            <h4>Logo Image</h4>
            <p className="subText">Size: 500 KB</p>
          </Col>
          <Col sxs={12} md={20}>
            <ImgCrop
              rotate
              modalTitle="Crop Image  *Image previews can be blurred. It will not affect quality of image."
              quality={1}
              fillColor="#00000000"
            >
              <Upload
                className="fileList-upload-images"
                maxCount={1}
                customRequest={postLogoImage}
                listType="picture-card"
                fileList={logoImageList}
                onPreview={handlePreview}
                onRemove={(e) => handleImageRemove(e?.name)}
                onChange={(e) => {
                  setLogoImageList(
                    logoImageList.filter((f) => f.uid !== e?.file?.uid)
                  );
                  setQrSettings({
                    ...qrSetting,
                    logoImage: "",
                  });
                }}
                accept="image/*"
              >
                {logoImageList.length === 1 ? null : <PlusOutlined />}
              </Upload>
            </ImgCrop>
            <Form.Item name={["qrSetting", "logoImage"]}>
              <Input type="hidden"></Input>
            </Form.Item>
          </Col>
        </Row>
        {qrSetting?.logoImage && (
          <>
            <Row gutter={10} style={{ marginTop: 24 }}>
              <Col span={4}>
                <h4>Logo Width</h4>
              </Col>
              <Col span={10}>
                <Form.Item name={["qrSetting", "logoWidth"]}>
                  <Slider max={150} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10} style={{ marginTop: 24 }}>
              <Col span={4}>
                <h4>Logo Height</h4>
              </Col>
              <Col span={10}>
                <Form.Item name={["qrSetting", "logoHeight"]}>
                  <Slider max={150} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={10} style={{ marginTop: 24 }}>
              <Col span={4}>
                <h4>Logo Opacity</h4>
              </Col>
              <Col span={10}>
                <Form.Item name={["qrSetting", "logoOpacity"]}>
                  <Slider max={1} min={0} step={0.1} />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </span>
      <PreviewImage
        previewImage={previewImage}
        previewVisible={previewVisible}
        setPreviewVisible={setPreviewVisible}
      ></PreviewImage>
    </>
  );
};

export default WaveCodeStyle;
